import _ from 'lodash';
import { FC, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from 'reflexbox';

import { useLocalize } from '@treams/treams-hooks';
import { Select } from '@treams/treams-ui';

import { GrowthPathData } from '../GrowthPathConverter';
import { GrowthPathContext } from '../contexts/GrowthPathContext';

type Props = {
	data: GrowthPathData;
};

const GrowthPathCompetencyLabelTabs: FC<Props> = ({ data }) => {
	const { t } = useTranslation();
	const { localize } = useLocalize();

	const { setLabelID, labelID } = useContext(GrowthPathContext);

	const labels = _.sortBy(
		_.uniqBy(
			data.jobCompetencies
				.flatMap((jobCompetency) => jobCompetency.competency.label)
				.filter(Boolean),
			'id',
		),
		(label) => localize(label!.title).text,
	);

	const options = labels.map((label) => {
		return {
			title: localize(label!.title).text,
			value: label!.id,
		};
	});

	if (data.hasCompetenciesWithoutLabel) {
		options.push({ title: t('growth.path.competency.label.otherSkills'), value: 'unlabeled' });
	}

	const getLabel = () => {
		if (labelID && labelID === 'unlabeled') {
			return 'unlabeled';
		}

		if (labelID) {
			return labels.find((label) => label!.id === labelID)?.id;
		}

		if (labels.length > 0) {
			return labels[0]!.id;
		}
	};

	const updateRoute = (value: string) => {
		setLabelID(value);
	};

	if (options.length < 2) {
		return null;
	}

	return (
		<Box width="100%">
			<Select
				options={options}
				search={false}
				selectedValue={getLabel()}
				placeholder={t('growth.path.competency.label.select.placeholder')}
				onChange={(value) => updateRoute(value!)}
			/>
		</Box>
	);
};

export default GrowthPathCompetencyLabelTabs;
